<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon>fab fa-instagram</v-icon>
        <span class="ml-1 title">Instagram</span>
      </v-card-title>
      <v-tabs
        v-model="tab"
        background-color="primary"
        dark
      >
        <v-tabs-slider></v-tabs-slider>
          <v-tab href="#tab-1">
            Aprobados
          </v-tab>
          <v-tab href="#tab-2">
            Explorar
          </v-tab>
      </v-tabs>
      <v-card-text>
        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-1">
            <v-card flat>
              <InstagramAproved></InstagramAproved>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-2">
            <v-card flat>
              <InstagramHashtag></InstagramHashtag>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import InstagramAproved from '../components/InstagramAproved'
import InstagramHashtag from '../components/InstagramHashtag'
export default {
  components: {
    InstagramAproved,
    InstagramHashtag
  },
  data () {
    return {
      tab: null
    }
  }
}
</script>
